import { useState } from 'react';
import { Modal } from '@/shared/components/ui/Modal';
import { Button } from '@/shared/components/ui/Button';
import { Input } from '@/shared/components/ui/Input';

export interface ScheduleInterviewModalProps {
  open: boolean;
  candidateName: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: (interviewAt: string, note: string) => void;
}

/**
 * Captures the interview date/time (+ optional note) before an application
 * advances to the 'interview' stage. The backend only books a Meeting and
 * drafts the interview_scheduled email when interviewAt is supplied on the
 * stage-move request, so this is the one place that value gets collected.
 */
export function ScheduleInterviewModal({ open, candidateName, loading, onClose, onConfirm }: ScheduleInterviewModalProps) {
  const [dateTime, setDateTime] = useState('');
  const [note, setNote] = useState('');

  function handleConfirm() {
    if (!dateTime) return;
    onConfirm(new Date(dateTime).toISOString(), note.trim());
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Schedule Interview"
      size="sm"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button onClick={handleConfirm} disabled={!dateTime} loading={loading}>
            Schedule
          </Button>
        </div>
      }
    >
      <div className="space-y-4 py-2">
        <p className="text-sm text-on-surface-variant">
          Set the interview date &amp; time for <strong>{candidateName}</strong>. This books a meeting slot for HR and
          drafts the invite email.
        </p>
        <Input
          name="interview-datetime"
          label="Interview date & time"
          type="datetime-local"
          value={dateTime}
          onChange={(e) => setDateTime(e.target.value)}
        />
        <Input
          name="interview-note"
          label="Note (optional)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="e.g. Panel round with engineering lead"
        />
      </div>
    </Modal>
  );
}
